/**
 * @generated SignedSource<<745810cf22c9372cd6137c69aac3657d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingStatus = "CONFIRMED" | "DRAFT";
export type ChargePaymentStatus = "AUTO_CHARGE" | "CANCELED" | "FULLY_REFUNDED" | "MARKED_PAID" | "NO_CHARGES" | "PAID" | "PARTIALLY_PAID" | "PARTIALLY_REFUNDED" | "PROCESSING" | "UNKNOWN" | "UNPAID";
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
export type SlotType = "BUCKET" | "MULTI" | "QUEUE" | "SINGLE";
import { FragmentRefs } from "relay-runtime";
export type BookingConfirmedModal_Booking$data = {
  readonly __typename: string;
  readonly id: string;
  readonly paymentStatus?: ChargePaymentStatus | null | undefined;
  readonly rounds?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly id?: string;
        readonly paymentStatus?: ChargePaymentStatus;
        readonly player: {
          readonly id: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly startSlot: {
    readonly agenda: {
      readonly date: string;
      readonly facility: {
        readonly club: {
          readonly slug: string;
          readonly supportsPrivate: boolean;
        } | null | undefined;
        readonly slug: string;
        readonly type: FacilityType;
      };
    };
    readonly availableCapacity?: number;
    readonly requirePlayerCounts?: boolean;
    readonly type: SlotType;
  } | null | undefined;
  readonly status?: BookingStatus;
  readonly " $fragmentSpreads": FragmentRefs<"BookingConfirmedModalShareSection_Booking">;
  readonly " $fragmentType": "BookingConfirmedModal_Booking";
};
export type BookingConfirmedModal_Booking$key = {
  readonly " $data"?: BookingConfirmedModal_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingConfirmedModal_Booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentStatus",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingConfirmedModal_Booking",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "bookingType",
                  "value": "STANDARD"
                }
              ],
              "kind": "ScalarField",
              "name": "availableCapacity",
              "storageKey": "availableCapacity(bookingType:\"STANDARD\")"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requirePlayerCounts",
              "storageKey": null
            }
          ],
          "type": "TimeSlot",
          "abstractKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "supportsPrivate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundConnection",
          "kind": "LinkedField",
          "name": "rounds",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoundEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "player",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        (v4/*: any*/)
                      ],
                      "type": "CustomerRound",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingConfirmedModalShareSection_Booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "332bd9a24de2ea70060f0643985e751e";

export default node;
